import { createReducer } from "@reduxjs/toolkit";
import {
  CATEGORIES_ERROR,
  CATEGORIES_LIST,
  CATEGORIES_LOADING,
} from "../actions/types";

const initials = {
  data: [],
  thisPage: 0,
  allPages: 0,
  error: false,
  loading: false,
};

const categoriesReducer = createReducer(initials, (builder) => {
  builder
    .addCase(CATEGORIES_LOADING, (s) => {
      s.loading = true;
    })
    .addCase(CATEGORIES_ERROR, (s, { payload }) => {
      s.error = payload;
      s.loading = false;
    })
    .addCase(CATEGORIES_LIST, (s, { payload }) => {
      s.data =
        payload?.thisPage === 1
          ? payload?.data
          : [...s?.data, ...payload?.data];
      s.count = payload.count;
      s.allPages = payload.allPages;
      s.thisPage = payload.thisPage;
      s.loading = false;
    });
});

export default categoriesReducer;
